import { ENDPOINT, SIGNATURE_TYPE } from "../../constants/endpoint.js"
import axios from 'axios'

const state = {
  error: null,
};

const mutations = {
  ERROR: (state, error) => {
    state.error = error
  },
};

const actions = {
  async createAccessories({ commit }, { data, documents }) {
    console.log("payload ", data, documents);

    const formData = new FormData();
    formData.append("registrationId", data.registrationId);
    formData.append("type", data.type);
    formData.append("accessories", JSON.stringify(data.accessories));

    for (const document of documents) {
      formData.append("files", document);
    }
    console.log("data ", formData.getAll("data"));
    console.log("files ", formData.getAll("files"));

    const config = {
      headers: {
        "content-type": "multipart/form-data",
        "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
      },
    };
    const url = ENDPOINT.CREATE_ACCESSORIES;
    await axios
      .post(url, formData, config)
      .then((response) => {
        commit("ERROR", null);
        console.log(response.data);

      })
      .catch((e) => {
        commit("ERROR", e.response.data.statusCode);
        console.log(e);
      })
      .finally(() => {
      });
  },
  async installAccessories({ commit }, { data, documents }) {
    console.log("payload ", data, documents);

    const formData = new FormData();
    formData.append("installationId", data.installationId);
    formData.append("files", data.imgNameVessel);
    formData.append("files", data.imgAIS);
    formData.append("files", data.imgVHF);
    formData.append("files", data.imgGPS);
    for (const document of documents) {
      formData.append("files", document);
    }

    // console.log("data ", formData.getAll("data")); 
    console.log("files ", formData.getAll("files"));

    const config = {
      headers: {
        "content-type": "multipart/form-data",
        "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
      },
    };
    const url = ENDPOINT.CREATE_ACCESSORIES;
    await axios
      .put(url, formData, config)
      .then(async (res) => {
        commit("ERROR", null);

        let signatureForm = {
          fileName: data.fileName,
          installationsId: data.installationId,
          type: SIGNATURE_TYPE.INSTALLATION
        }

        const config = {
          headers: {
            // "content-type": "multipart/form-data",
            "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
          },
        };

        const createSignatureUrl = ENDPOINT.CREATE_SIGNATURE_BY_FILENAME
        await axios.post(createSignatureUrl, signatureForm, config)
          .then(async (res) => {
            console.log(res);

          })
          .catch(async (error) => {
            console.log(error);
          })
      })
      .catch((e) => {
        commit("ERROR", e.response.data.statusCode);
        console.log(e);
      })
      .finally(() => {
      });
  },
  async updateAccessories({ commit }, { data, documents }) {
    console.log("payload ", data, documents);

    const formData = new FormData();
    formData.append("installations", JSON.stringify(data.installations));
    formData.append("registrationId", data.registrationId);
    formData.append("type", data.type);
    formData.append("accessories", JSON.stringify(data.accessories));

    for (const document of documents) {
      formData.append("files", document);
    }
    console.log("accessories ", formData.getAll("accessories"));
    console.log("files ", formData.getAll("files"));

    const config = {
      headers: {
        "content-type": "multipart/form-data",
        "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
      },
    };
    const url = `${ENDPOINT.UPDATE_ACCESSORIES}/${data.installationId}`;
    await axios
      .put(url, formData, config)
      .then((response) => {
        commit("ERROR", null);
        console.log(response.data);

      })
      .catch((e) => {
        commit("ERROR", e.response.data.statusCode);
        console.log(e);
      })
      .finally(() => {
      });
  },
  async updateInstallAccessories({ commit }, { data, documents }) {
    console.log("payload ", data, documents);

    const formData = new FormData();
    formData.append("installationId", data.installationId);
    formData.append("imgNameVessel", data.imgNameVessel);
    formData.append("imgAIS", data.imgAIS);
    formData.append("imgVHF", data.imgVHF);
    formData.append("imgGPS", data.imgGPS);
    for (const document of documents) {
      formData.append("documents", document);
    }

    // console.log("data ", formData.getAll("data")); 
    console.log("files ", formData.getAll("files"));

    const config = {
      headers: {
        "content-type": "multipart/form-data",
        "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
      },
    };
    const url = `${ENDPOINT.UPDATE_INSTALLATION}/${data.installationId}`;
    await axios
      .put(url, formData, config)
      .then(async (res) => {
        commit("ERROR", null);
      })
      .catch((e) => {
        commit("ERROR", e.response.data.statusCode);
        console.log(e);
      })
      .finally(() => {
      });
  },


  //reparation
  async createAccessoriesReparation({ commit }, { data, documents }) {
    console.log("payload ", data, documents);

    const formData = new FormData();
    formData.append("reparationId", data.reparationId);
    formData.append("type", data.type);
    formData.append("accessories", JSON.stringify(data.accessories));

    for (const document of documents) {
      formData.append("files", document);
    }
    console.log("data ", formData.getAll("data"));
    console.log("files ", formData.getAll("files"));

    const config = {
      headers: {
        "content-type": "multipart/form-data",
        "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
      },
    };
    const url = ENDPOINT.CREATE_NEW_ACCESSORIES_REPARATION;
    await axios
      .post(url, formData, config)
      .then((res) => {
        commit("ERROR", null);
        console.log(res);
      })
      .catch((e) => {
        commit("ERROR", e.response.data.statusCode);
        console.log(e);
      })
      .finally(() => {
      });
  },
  async installAccessoriesReparation({ commit }, { data, documents, fileName }) {
    console.log("payload ", data, documents);

    const formData = new FormData();
    formData.append("reparationId", data.reparationId);
    formData.append("installationId", data.installationId);
    formData.append("files", data.imgNameVessel);
    formData.append("files", data.imgAIS);
    formData.append("files", data.imgVHF);
    formData.append("files", data.imgGPS);
    for (const document of documents) {
      formData.append("files", document);
    }

    // console.log("data ", formData.getAll("data")); 
    console.log("files ", formData.getAll("files"));

    const config = {
      headers: {
        "content-type": "multipart/form-data",
        "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
      },
    };
    const url = ENDPOINT.CONFIRM_INSTALL_ACCESSORIES_REPARATION;
    await axios
      .put(url, formData, config)
      .then(async (res) => {
        commit("ERROR", null);
        console.log(res);

        let sigantureForm = {
          fileName: data.fileName,
          installationsId: res.data.installations[0].id,
          type: SIGNATURE_TYPE.INSTALLATION
        }

        const config = {
          headers: {
            // "content-type": "multipart/form-data",
            "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
          },
        };

        const createSignatureUrl = ENDPOINT.CREATE_SIGNATURE_BY_FILENAME
        await axios.post(createSignatureUrl, sigantureForm, config)
          .then((res) => {
            console.log(res);
          })
          .catch((error) => {
            console.log(error);
          })
      })
      .catch((e) => {
        commit("ERROR", e.response.data.statusCode);
        console.log(e);
      })
      .finally(() => {
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
